import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type MedallionVariant =
  | 'brand'
  | 'accent'
  | 'saffron'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'plum';

/**
 * `<nb-medallion>` — a 46×46 rounded icon tile. Hue mapping to the 2026-09
 * prototype: green = brand/success, sky = accent/info, sand = saffron/warning,
 * rose = danger.
 *
 * Projects a single `<nb-icon>` sized to 22px via `--nb-icon-size`. Purely
 * presentational: it tints a soft background + matching foreground per
 * `variant`. The projected icon is decorative by default (inherits nb-icon's
 * `aria-hidden`); give the icon a `label` when it conveys meaning.
 *
 * @example
 * <nb-medallion variant="brand"><nb-icon [icon]="Home"/></nb-medallion>
 * <nb-medallion variant="success"><nb-icon [icon]="Check" label="Fullført"/></nb-medallion>
 */
@Component({
  selector: 'nb-medallion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'med',
    '[class]': 'variant()',
  },
  template: `<ng-content />`,
  styleUrl: './medallion.css',
})
export class NbMedallion {
  readonly variant = input<MedallionVariant>('brand');
}
